import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import imageSource from "./BankIdLogo.svg.js";
var Logo = styled.img.withConfig({
  displayName: "BankIdLogo__Logo",
  componentId: "sc-19pbqe7-0"
})(["width:", "px;"], function (props) {
  return props.width;
});

var BankIdLogo = function BankIdLogo(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 150 : _ref$width;
  return /*#__PURE__*/React.createElement(Logo, {
    src: imageSource,
    alt: "BankId logo",
    width: width
  });
};

BankIdLogo.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The desired width in px of the logo. The height will automatically be adjusted by the width.
   */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
export default BankIdLogo;
//# sourceMappingURL=BankIdLogo.js.map